import axios from '@axios'

const group = 'salary_and_commission/'
const route = 'customize_commission'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, { itemsPerPage, page, search }) {
      return axios.get(`${group + route}?page=${page}&items_per_page=${itemsPerPage}&search=${search}`)
    },

    store(context, customizeCommission) {
      return axios.post(group + route, customizeCommission)
    },

    update(context, customizeCommission) {
      return axios.put(`${group + route}/${customizeCommission.id}`, customizeCommission)
    },

    destroy(context, customizeCommission) {
      return axios.delete(`${group + route}/${customizeCommission.id}`)
    },

  },
}
